// src/utils/phoneUtils.js
// LOOP PHONE FOUNDATION — single source of truth for phone normalization/display.
// Phase 1C: local SVG flags, no CDN/network dependency.
// Internal storage should prefer E.164: +50761234567
// Human display for Panama: +507 6123-4567


import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

function svgDataUri(svg) {
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

const FLAG_SVG_BY_COUNTRY = {
  PA: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#fff" d="M0 0h32v24H0z"/><path fill="#d21034" d="M32 0h32v24H32z"/><path fill="#005293" d="M0 24h32v24H0z"/><path fill="#fff" d="M32 24h32v24H32z"/><path fill="#005293" d="m16 7 2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z"/><path fill="#d21034" d="m48 31 2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z"/></svg>`,
  US: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#b22234" d="M0 0h64v48H0z"/><path stroke="#fff" stroke-width="3.69" d="M0 3.7h64M0 11.1h64M0 18.5h64M0 25.8h64M0 33.2h64M0 40.6h64"/><path fill="#3c3b6e" d="M0 0h28v25.8H0z"/><g fill="#fff"><circle cx="5" cy="5" r="1.1"/><circle cx="12" cy="5" r="1.1"/><circle cx="19" cy="5" r="1.1"/><circle cx="25" cy="5" r="1.1"/><circle cx="8" cy="11" r="1.1"/><circle cx="15" cy="11" r="1.1"/><circle cx="22" cy="11" r="1.1"/><circle cx="5" cy="17" r="1.1"/><circle cx="12" cy="17" r="1.1"/><circle cx="19" cy="17" r="1.1"/><circle cx="25" cy="17" r="1.1"/></g></svg>`,
  CO: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#fcd116" d="M0 0h64v24H0z"/><path fill="#003893" d="M0 24h64v12H0z"/><path fill="#ce1126" d="M0 36h64v12H0z"/></svg>`,
  CR: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#002b7f" d="M0 0h64v48H0z"/><path fill="#fff" d="M0 8h64v32H0z"/><path fill="#ce1126" d="M0 16h64v16H0z"/></svg>`,
  MX: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#006847" d="M0 0h21.33v48H0z"/><path fill="#fff" d="M21.33 0h21.34v48H21.33z"/><path fill="#ce1126" d="M42.67 0H64v48H42.67z"/><circle cx="32" cy="24" r="5" fill="#c09300"/><circle cx="32" cy="24" r="2.5" fill="#6b8e23"/></svg>`,
  CL: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#fff" d="M0 0h64v24H0z"/><path fill="#d52b1e" d="M0 24h64v24H0z"/><path fill="#0039a6" d="M0 0h24v24H0z"/><path fill="#fff" d="m12 5 2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z"/></svg>`,
  AR: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#74acdf" d="M0 0h64v48H0z"/><path fill="#fff" d="M0 16h64v16H0z"/><circle cx="32" cy="24" r="4" fill="#f6b40e"/></svg>`,
  PY: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#d52b1e" d="M0 0h64v16H0z"/><path fill="#fff" d="M0 16h64v16H0z"/><path fill="#0038a8" d="M0 32h64v16H0z"/><circle cx="32" cy="24" r="4" fill="#f6b40e"/></svg>`,
  BO: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#d52b1e" d="M0 0h64v16H0z"/><path fill="#f9e300" d="M0 16h64v16H0z"/><path fill="#007934" d="M0 32h64v16H0z"/></svg>`,
  VE: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#fcd116" d="M0 0h64v16H0z"/><path fill="#003893" d="M0 16h64v16H0z"/><path fill="#ce1126" d="M0 32h64v16H0z"/><g fill="#fff"><circle cx="20" cy="24" r="1.2"/><circle cx="26" cy="22" r="1.2"/><circle cx="32" cy="21" r="1.2"/><circle cx="38" cy="22" r="1.2"/><circle cx="44" cy="24" r="1.2"/></g></svg>`,
  SV: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#0f47af" d="M0 0h64v48H0z"/><path fill="#fff" d="M0 16h64v16H0z"/><circle cx="32" cy="24" r="4" fill="#f6b40e"/></svg>`,
  NI: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#0067c6" d="M0 0h64v48H0z"/><path fill="#fff" d="M0 16h64v16H0z"/><circle cx="32" cy="24" r="4" fill="#f6b40e"/></svg>`,
  GT: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#4997d0" d="M0 0h21.33v48H0zM42.67 0H64v48H42.67z"/><path fill="#fff" d="M21.33 0h21.34v48H21.33z"/><circle cx="32" cy="24" r="4" fill="#6b8e23"/></svg>`,
  HN: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#18a9e6" d="M0 0h64v48H0z"/><path fill="#fff" d="M0 16h64v16H0z"/><g fill="#18a9e6"><circle cx="26" cy="22" r="1.2"/><circle cx="32" cy="22" r="1.2"/><circle cx="38" cy="22" r="1.2"/><circle cx="29" cy="27" r="1.2"/><circle cx="35" cy="27" r="1.2"/></g></svg>`,
  PE: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#d91023" d="M0 0h21.33v48H0zM42.67 0H64v48H42.67z"/><path fill="#fff" d="M21.33 0h21.34v48H21.33z"/></svg>`,
  EC: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#fcd116" d="M0 0h64v24H0z"/><path fill="#003893" d="M0 24h64v12H0z"/><path fill="#ce1126" d="M0 36h64v12H0z"/><circle cx="32" cy="24" r="4" fill="#8b5a2b"/></svg>`,
  DO: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#002d62" d="M0 0h28v20H0zM36 28h28v20H36z"/><path fill="#ce1126" d="M36 0h28v20H36zM0 28h28v20H0z"/><path fill="#fff" d="M28 0h8v48h-8zM0 20h64v8H0z"/></svg>`,
  UY: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#fff" d="M0 0h64v48H0z"/><path stroke="#0038a8" stroke-width="5.33" d="M0 13.3h64M0 24h64M0 34.7h64M0 45.3h64"/><path fill="#fff" d="M0 0h28v26H0z"/><circle cx="14" cy="13" r="5" fill="#f6b40e"/></svg>`,
  BR: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#009b3a" d="M0 0h64v48H0z"/><path fill="#ffdf00" d="m32 6 24 18-24 18L8 24z"/><circle cx="32" cy="24" r="10" fill="#002776"/><path stroke="#fff" stroke-width="2" d="M22 22c7-2 14-1 20 3"/></svg>`,
  ES: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path fill="#aa151b" d="M0 0h64v48H0z"/><path fill="#f1bf00" d="M0 12h64v24H0z"/><rect x="18" y="18" width="6" height="10" rx="1" fill="#aa151b"/></svg>`,
};

function flagSvg(countryCode = "PA") {
  const code = String(countryCode || "PA").toUpperCase();
  return FLAG_SVG_BY_COUNTRY[code] || `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><rect width="64" height="48" rx="6" fill="#f8fafc"/><text x="32" y="29" text-anchor="middle" font-family="Arial, sans-serif" font-size="15" font-weight="700" fill="#334155">${code}</text></svg>`;
}

export function getFlagImage(countryCode = "PA") {
  return svgDataUri(flagSvg(countryCode));
}

export const LOOP_PHONE_COUNTRIES = [
  // Main operating countries first (Latin America first, like marketplace apps)
  { countryCode: "PA", dialCode: "+507", label: "Panamá", placeholder: "6123-4567", nationalLength: 8, format: "4-4", priority: 1 },
  { countryCode: "CO", dialCode: "+57", label: "Colombia", placeholder: "300 000 0000", nationalLength: 10, format: "3-3-4", priority: 2 },
  { countryCode: "CR", dialCode: "+506", label: "Costa Rica", placeholder: "8888-8888", nationalLength: 8, format: "4-4", priority: 3 },
  { countryCode: "US", dialCode: "+1", label: "Estados Unidos", placeholder: "555 000 0000", nationalLength: 10, format: "3-3-4", priority: 4 },
  { countryCode: "MX", dialCode: "+52", label: "México", placeholder: "55 0000 0000", nationalLength: 10, format: "2-4-4", priority: 5 },

  { countryCode: "BZ", dialCode: "+501", label: "Belice", placeholder: "622 1234", nationalLength: 7, priority: 33 },
  { countryCode: "PR", dialCode: "+1", label: "Puerto Rico", placeholder: "787 234 5678", nationalLength: 10, format: "3-3-4", priority: 34 },
  // LATAM expansion
  { countryCode: "CL", dialCode: "+56", label: "Chile", placeholder: "9 0000 0000", nationalLength: 9, format: "1-4-4", priority: 20 },
  { countryCode: "AR", dialCode: "+54", label: "Argentina", placeholder: "11 0000-0000", nationalLength: 10, format: "2-4-4", priority: 21 },
  { countryCode: "PY", dialCode: "+595", label: "Paraguay", placeholder: "981 000 000", nationalLength: 9, format: "3-3-3", priority: 22 },
  { countryCode: "BO", dialCode: "+591", label: "Bolivia", placeholder: "7000 0000", nationalLength: 8, format: "4-4", priority: 23 },
  { countryCode: "VE", dialCode: "+58", label: "Venezuela", placeholder: "412 000 0000", nationalLength: 10, format: "3-3-4", priority: 24 },
  { countryCode: "SV", dialCode: "+503", label: "El Salvador", placeholder: "7000-0000", nationalLength: 8, format: "4-4", priority: 25 },
  { countryCode: "NI", dialCode: "+505", label: "Nicaragua", placeholder: "8000-0000", nationalLength: 8, format: "4-4", priority: 26 },
  { countryCode: "GT", dialCode: "+502", label: "Guatemala", placeholder: "5000-0000", nationalLength: 8, format: "4-4", priority: 27 },
  { countryCode: "HN", dialCode: "+504", label: "Honduras", placeholder: "9000-0000", nationalLength: 8, format: "4-4", priority: 28 },
  { countryCode: "PE", dialCode: "+51", label: "Perú", placeholder: "900 000 000", nationalLength: 9, format: "3-3-3", priority: 29 },
  { countryCode: "EC", dialCode: "+593", label: "Ecuador", placeholder: "99 000 0000", nationalLength: 9, format: "2-3-4", priority: 30 },
  { countryCode: "DO", dialCode: "+1", label: "República Dominicana", placeholder: "809 000 0000", nationalLength: 10, format: "3-3-4", priority: 31 },
  { countryCode: "UY", dialCode: "+598", label: "Uruguay", placeholder: "94 000 000", nationalLength: 8, format: "2-3-3", priority: 32 },

  // Other useful countries
  { countryCode: "BR", dialCode: "+55", label: "Brasil", placeholder: "11 99999-9999", nationalLength: 11, format: "2-5-4", priority: 40 },
  { countryCode: "ES", dialCode: "+34", label: "España", placeholder: "600 000 000", nationalLength: 9, format: "3-3-3", priority: 41 },
].map((country) => ({
  ...country,
  flagUrl: getFlagImage(country.countryCode),
  flagUrl2x: getFlagImage(country.countryCode),
}));

export function phoneDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

export function getFlagEmoji(countryCode = "PA") {
  const code = String(countryCode || "PA").toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return "";
  return code
    .split("")
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join("");
}

export function findPhoneCountry(value = "PA") {
  const raw = String(value || "").trim().toUpperCase();
  const digits = phoneDigits(raw);
  return (
    LOOP_PHONE_COUNTRIES.find((c) => c.countryCode === raw) ||
    LOOP_PHONE_COUNTRIES.find((c) => c.dialCode === raw) ||
    LOOP_PHONE_COUNTRIES.find((c) => phoneDigits(c.dialCode) === digits) ||
    LOOP_PHONE_COUNTRIES[0]
  );
}

export function cleanPhoneNationalInput(value = "", country = "PA") {
  const meta = findPhoneCountry(country);
  const digits = phoneDigits(value);
  const max = Number(meta.nationalLength || 0);
  const trimmed = digits.slice(0, 15);
  return formatPhoneNational(trimmed, meta.countryCode);
}

function groupDigits(digits, groups = [], separator = "-") {
  const clean = phoneDigits(digits);
  const out = [];
  let idx = 0;
  for (const size of groups) {
    if (idx >= clean.length) break;
    out.push(clean.slice(idx, idx + size));
    idx += size;
  }
  if (idx < clean.length) out.push(clean.slice(idx));
  return out.filter(Boolean).join(separator);
}

export function formatPhoneNational(value = "", country = "PA") {
  const meta = findPhoneCountry(country);
  const digits = phoneDigits(value);

  if (!digits) return "";

  if (["PA", "CR", "SV", "NI", "GT", "HN", "BO"].includes(meta.countryCode)) {
    return groupDigits(digits, [4, 4], "-");
  }
  if (["US", "CO", "PE", "ES", "PY", "VE"].includes(meta.countryCode)) {
    return groupDigits(digits, [3, 3, 4], " ");
  }
  if (["MX", "AR", "EC"].includes(meta.countryCode)) {
    return groupDigits(digits, [2, 4, 4], " ");
  }
  if (meta.countryCode === "BR") {
    return `${digits.slice(0, 2)}${digits.length > 2 ? " " : ""}${groupDigits(digits.slice(2), [5, 4], "-")}`.trim();
  }
  if (meta.countryCode === "CL") {
    return `${digits.slice(0, 1)}${digits.length > 1 ? " " : ""}${groupDigits(digits.slice(1), [4, 4], " ")}`.trim();
  }
  if (meta.countryCode === "UY") {
    return groupDigits(digits, [2, 3, 3], " ");
  }

  return digits.replace(/(\d{3})(?=\d)/g, "$1 ").trim();
}

export function parsePhoneValue(value = "", options = {}) {
  const fallback = findPhoneCountry(options.defaultCountry || options.countryCode || options.dialCode || "PA");
  let raw = String(value || "").trim();
  if (!raw.startsWith('+') && phoneDigits(raw).length === 11 && phoneDigits(raw).startsWith('507') && fallback.countryCode === 'PA') raw = '+' + phoneDigits(raw);
  const parsed = parsePhoneNumberFromString(raw, fallback.countryCode);
  const country = findPhoneCountry(parsed?.country || fallback.countryCode);
  const nationalNumber = parsed?.nationalNumber || phoneDigits(raw);
  const nationalFormatted = formatPhoneNational(nationalNumber, country.countryCode);
  const e164 = parsed?.number || (nationalNumber ? `${country.dialCode}${nationalNumber}` : '');
  const dialCode = parsed ? `+${parsed.countryCallingCode}` : country.dialCode;
  const display = parsed ? parsed.formatInternational() : nationalNumber ? `${dialCode} ${nationalFormatted}` : '';
  return { countryCode:country.countryCode, dialCode, countryLabel:country.label, placeholder:country.placeholder,
    flagUrl:country.flagUrl, flagUrl2x:country.flagUrl2x, flagEmoji:getFlagEmoji(country.countryCode),
    nationalNumber, nationalFormatted, localPhone:nationalFormatted, phoneNational:nationalNumber,
    e164, phoneE164:e164, whatsappDigits:phoneDigits(e164), display, phoneDisplay:display, isValid:Boolean(parsed?.isValid()) };
}

export function joinPhoneDisplay(dialCode = "+507", nationalValue = "") {
  const country = findPhoneCountry(dialCode);
  const cleanNational = phoneDigits(nationalValue);
  if (!cleanNational) return "";
  return `${country.dialCode} ${formatPhoneNational(cleanNational, country.countryCode)}`.trim();
}

export function normalizePhoneToE164(value = "", defaultCountry = "PA") {
  return parsePhoneValue(value, { defaultCountry }).e164;
}

export function formatPhoneDisplay(value = "", defaultCountry = "PA") {
  return parsePhoneValue(value, { defaultCountry }).display || String(value || "").trim();
}

export function phoneSnapshot(value = "", defaultCountry = "PA") {
  const parsed = parsePhoneValue(value, { defaultCountry });
  return {
    phone: parsed.display,
    phoneDisplay: parsed.display,
    phoneE164: parsed.e164,
    phoneNormalized: parsed.e164,
    phoneCountryCode: parsed.countryCode,
    phoneDialCode: parsed.dialCode,
    phoneNational: parsed.nationalNumber,
    phoneVerified: false,
  };
}

export function phoneSnapshotFromParts(dialCode = "+507", nationalValue = "") {
  return phoneSnapshot(joinPhoneDisplay(dialCode, nationalValue), findPhoneCountry(dialCode).countryCode);
}

export function maskPhoneDisplay(value = "", defaultCountry = "PA") {
  const parsed = parsePhoneValue(value, { defaultCountry });
  if (!parsed.e164) return "";
  if (parsed.countryCode === "PA" && parsed.nationalNumber.length === 8) {
    return `${parsed.dialCode} ${parsed.nationalNumber.slice(0, 4)}-••••`;
  }
  const shown = parsed.nationalNumber.slice(0, 3);
  return `${parsed.dialCode} ${shown}${"•".repeat(Math.max(0, parsed.nationalNumber.length - 3))}`;
}
